import React from 'react';
import { Create, SimpleForm, TextInput, required, useTranslate } from 'react-admin';
import { FormPageTitle, FormSection, FormToolbar } from '@/components/shell';

const BACK_TO = '/kyc-config?tab=document-types';

export const DocumentTypeCreate = () => {
  const t = useTranslate();
  return (
    <Create actions={<FormPageTitle mode="create" />}>
      <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} />}>
        <FormSection title={t('resources.document-types.name', { smart_count: 1 })}>
          <TextInput source="name" label={t('resources.document-types.fields.name')} validate={required()} fullWidth />
        </FormSection>
      </SimpleForm>
    </Create>
  );
};
